export default "__VITE_ASSET__ChIHf6g6__"